import { t } from "i18next";
import {FC, useState} from "react";
import { SelectAvatar } from "../../shared/components/organisms/SelectAvatar";
import { Select } from "@/shared/components/organisms/Select";
import { ButtonPrimary } from "@/shared/components/atoms/ButtonPrimary";
import { ButtonSoft } from "@/shared/components/atoms/ButtonSoft";
import { Avatar } from "@/shared/components/atoms/Avatar";
import {useParams} from "react-router-dom";
import 'react-quill/dist/quill.snow.css';
import DOMPurify from "dompurify";
import {ShippingRules} from "@/pages/InternalChats/ShippingRules";
import {Form, Formik} from "formik";
import {usePostMeta} from "@/pages/InternalChats/hooks/usePostMeta";
import {internalChatValidationSchema} from "@/pages/InternalChats/constants/validationSchema";
import {buildInternalChatInitialValues} from "@/pages/InternalChats/constants/initialValuesFactory";
import {RichTextEditor} from "@/shared/components/molecules/RichTextEditor";
import {CreatePostPayload, useCreatePostMutation} from "@/app/post-internal-chats/post-internal-chats.api";
import {buildCreatePostPayload} from "@/pages/InternalChats/utils/handlePublish";
import { toasts } from "@/shared/utils/toasts";


export const PostInternalChats: FC<any> = () => {

  const { id } = useParams<{ id: string }>();
  const branchId = Number(id);
  const { managersOpts, reactionsOpts, setsOpts, data, isLoading, error } = usePostMeta(branchId)

   const [open, setOpen] = useState(false);
   const initialValues = buildInternalChatInitialValues(
     managersOpts,
     reactionsOpts,
     setsOpts
   );

   const [createPost, { isLoading: isLoadingPost, isSuccess, isError }] =
     useCreatePostMutation();

  const handleDraft = async (vals:any) => {
    console.log(vals)
    try {
      const payload = buildCreatePostPayload(vals, branchId);
      payload.state = 'draft';
      const sanitized = Object.fromEntries(
          Object.entries(payload).filter(([, v]) => v != null)
      ) as CreatePostPayload;
      await createPost(sanitized).unwrap();
      toasts.success("Post registrado", "El post se ha guardado correctamente")
    } catch (err) {
      console.error("Error al publicar:", err);
      toasts.success("Error", "No se ha podido guardar el post")
    }
  }

  const handlePublish = async (val:any, formikHelpers:any) => {
    try {
      const payload = buildCreatePostPayload(val, branchId);
      payload.state = 'scheduled';
      const sanitized = Object.fromEntries(
          Object.entries(payload).filter(([, v]) => v != null)
      ) as CreatePostPayload;
      await createPost(sanitized).unwrap();
      // formikHelpers.resetForm();
      toasts.success("Post publicado", "El post se ha publicado correctamente");
    } catch (err) {
      console.error("Error al publicar:", err);
      toasts.success("Error", "No se ha publicado el post");
    }
  }


  return (

      <Formik
          initialValues={initialValues}
          validationSchema={internalChatValidationSchema}
          onSubmit={(val:any, helpers:any) => {
            handlePublish(val,helpers)
          }}
          enableReinitialize
      >
        {(formik) => {
          return (
            <Form className={'flex justify-start w-full h-[calc(100vh-64px)] pt-2 overflow-y-auto'}>
              <div className="flex w-full">
                <div className="w-full sm:max-w-full md:max-w-full lg:max-w-full xl:max-w-full 2xl:max-w-full mx-auto mb-8">
                  <div className="flex flex-col xl:flex-row xl:gap-x-2 px-4 bottom pb-2 border-b">
                    <div className="flex flex-col flex-1 gap-4 xl:gap-2 xl:flex-row xl:items-start">
                      <div className="col-span-full">
                        {managersOpts.length > 0 && (
                            <SelectAvatar
                                tittle={t("posts-master.views.from")}
                                selected={formik.values.from}
                                setSelected={(val) => formik.setFieldValue("from", val)}
                                options={managersOpts}
                            />
                        )}
                      </div>
                      <div className="col-span-full">
                        {managersOpts.length > 0 && (
                            <SelectAvatar
                                tittle={t("posts-master.views.assign_to")}
                                selected={formik.values.assign_to}
                                setSelected={(val) => formik.setFieldValue("assign_to", val)}
                                options={managersOpts}
                            />
                        )}
                      </div>
                      <div className="col-span-full">
                        <Select
                            tittle={t("posts-master.views.type_reaction")}
                            selected={formik.values.type_reaction}
                            setSelected={(val) => formik.setFieldValue("type_reaction", val)}
                            options={reactionsOpts}
                        />
                      </div>
                      <div className="col-span-full">
                        <Select
                            tittle="Set"
                            selected={formik.values.set}
                            setSelected={(val) => formik.setFieldValue("set", val)}
                            options={setsOpts}
                        />
                      </div>
                    </div>
                    <div className="flex flex-col xl:flex-row xl:items-center gap-3 gap-x-2 xl:gap-x-2 pt-6 xl:pt-0 xl:self-end">
                      <ButtonPrimary
                          type="submit"
                          size="large"
                          text={t("posts-master.views.active")}
                          disabled={false}
                      />
                      <ButtonSoft
                          size="large"
                          text={t("posts-master.views.save_draft")}
                          className="mt-2 xl:mt-0"
                          onClick={() => {
                            console.log("Gender en formik:", formik.values.gender);
                            handleDraft(formik.values)
                          }}
                          disabled={false}
                      />
                      <ButtonSoft
                          onClick={() => setOpen(true)}
                          size="large"
                          text={t("posts-master.views.post_shipping_rules")}
                          className="mt-5 xl:mt-0"
                      />
                    </div>
                  </div>

                  {/* ACA VAN LAS DOS COLUMNAS */}
                  <div className="grid grid-cols-1 xl:grid-cols-2 p-4">
                    <div className="flex flex-col space-y-4">
                      {/* Contenido de la columna izquierda */}
                      <div className="bg-white">
                        {/*INICIO TELEFONO*/}
                        <div className="flex justify-center mt-5">
                          {/* Contenedor del teléfono */}
                          <div className="relative w-[350px] h-[700px] bg-black rounded-[50px] shadow-2xl">
                            {/* Notch del iPhone */}
                            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-[150px] h-[30px] bg-black rounded-b-2xl z-10"></div>

                            {/* Pantalla del teléfono */}
                            <div className="absolute inset-0 m-4 bg-white rounded-[40px] overflow-hidden">
                              {/* Encabezado */}
                              <div className="relative flex items-center justify-between p-4 pt-12">
                                <button className="text-purple-500">
                                  {/* Ícono de flecha */}
                                  <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                      className="w-6 h-6"
                                  >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M15 19l-7-7 7-7"
                                    />
                                  </svg>
                                </button>
                                <span className="text-black text-xl font-semibold">
                          {formik.values.from?.name || "Nombre"}
                        </span>
                                <Avatar
                                    size="large"
                                    src={formik.values.from?.avatar || "https://randomuser.me/api/portraits/men/1.jpg"}
                                />
                              </div>

                              {/* Área de contenido con borde (más grande) */}
                              <div
                                  id={'rich-editor'}
                                  className="h-[480px] overflow-y-auto rounded-md my-2 p-4"
                                  style={{ backgroundColor: "#F1F1F1" }}
                                  dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(formik.values.richValue) }}
                              ></div>

                              {formik.values.type_reaction?.id === 2 && (
                                  <div className="flex justify-center mt-2">
                                    <span className="text-2xl mx-1">🎉</span>
                                    <span className="text-2xl mx-1">💜</span>
                                    <span className="text-2xl mx-1">🥳</span>
                                    <span className="text-2xl mx-1">👎</span>
                                  </div>
                              )}

                              {formik.values.type_reaction?.id === 1 && (
                                  <div className="flex justify-center mt-2">
                                    <span className="text-2xl mx-1">📝</span>
                                    <span className="text-2xl mx-1">🅰️</span>
                                    <span className="text-2xl mx-1">⌨️</span>
                                  </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/*FIN TELEFONO */}
                      </div>
                    </div>

                    <div className="flex flex-col space-y-4">
                      {/* Contenido de la columna derecha */}
                      <div className="bg-white mt-10 sm:mt-20">
                        <div className="relative">
                          <RichTextEditor
                              title={formik.values.title}
                              setTitle={(val: string) => formik.setFieldValue("title", val)}
                              richValue={formik.values.richValue}
                              setRichValue={(val: string) => formik.setFieldValue("richValue", val)}
                              error={formik.touched.richValue && Boolean(formik.errors.richValue)}
                              textError={formik.errors.richValue}
                              onError={(hasError: boolean) => {
                                if (hasError) {
                                  formik.setFieldTouched("richValue", true, false);
                                }
                              }}
                              required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <ShippingRules formik={formik} setOpen={setOpen} openDialog={open} data={data}/>

                </div>
              </div>
            </Form>
          )
        }}
      </Formik>


  );
};